import HeaderV2 from "../header";

export default function HomeV2({ }) {


    return (
        <div style={{ color: 'white' }}>
            <HeaderV2 />
            Home V2

        </div>
    )
}